import type { ReactNode } from "react";
import styles from "./Notice.module.css";

interface NoticeProps {
  /** Circular icon shown above the title (WarningIcon / LockIcon / …). */
  readonly icon: ReactNode;
  readonly title: string;
  readonly message: ReactNode;
  /** Optional action below the message (e.g. a Retry button). */
  readonly action?: ReactNode;
}

/**
 * Full-pane notice layout shared by the add-in's blocking states
 * (AccountNotFoundNotice, ChannelUnavailableNotice, ConnectionErrorNotice,
 * AccessBlockedNotice). Centralises the container / icon / title / message
 * markup + styles so each notice only supplies its icon, copy, and optional
 * action.
 */
export function Notice({ icon, title, message, action }: Readonly<NoticeProps>) {
  return (
    <output className={styles.container}>
      <div className={styles.iconWrap} aria-hidden="true">
        {icon}
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.message}>{message}</p>
      {action}
    </output>
  );
}
